import { render, staticRenderFns } from "./vue-image.vue?vue&type=template&id=2c61ec32&"
import script from "./vue-image.vue?vue&type=script&lang=js&"
export * from "./vue-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports